export enum SCHEDULE_TYPE {
    //Ticketing campign reminders
    TICKET_REMINDER = 1,
    TICKET_ADD_GUEST_REMINDER = 2,
    TICKET_INVITE_REMINDER = 9,

    //Pending Cart Reminder
    PENDING_CART_REMINDER = 3,

    //Silent Auction
    SILENT_AUCTION_CLOSING = 4,
    CLOSE_AUCTION = 5,
    CUSTOM_SILENT_AUCTION_REMINDER = 17,

    // Virtual Event Reminder
    VIRTUAL_EVENT_REMINDER = 6,
    VIRTUAL_EVENT_INVITE_REMINDER = 11,

    //Remindes for all connected ticket campigns
    IN_PERSON_EVENT_REMINDER = 7,
    IN_PERSON_ADD_GUEST_REMINDER = 8,
    IN_PERSON_SAVE_CARD_REMINDER = 13,

    // Event Page
    EVENT_PAGE_INVITE_REMINDER = 10,

    // Peer to peer Reminder
    P2P_UPDATE_TO_CHAMPIAN = 12,

    // Party Signups
    SEND_PARTY_SIGNUP_REMINDER = 14,
    SEND_PARTY_SIGNUP_REMINDER_TO_HOST = 15,

    //Merchandise Reminders
    SCHEDULE_TASK_SEND_SHOPPING_REMINDER = 16,
}